import React from "react";
import MainLayout from "../components/Layout/MainLayout";
import { tutorial, home } from "../styles/theme";
import uploadGuide from "../assets/guide/upload-basespace.pdf";
import tokenGuide from "../assets/guide/generate-basespace-token.pdf";
import croGuide from "../assets/guide/CRO-pipeline-guide.pdf"; // adjust filename if needed
import caurisGuide from "../assets/guide/C.auris-pipeline-guide.pdf"; // adjust filename if needed
import sarsGuide from "../assets/guide/SARS-CoV-2-pipeline-guide.pdf"; // adjust filename if needed
import phyloGuide from "../assets/guide/PhyloTree-pipeline-guide.pdf"; // adjust filename if needed
import { FaEnvelope } from "react-icons/fa";

const TutorialContent = () => {
  return (
    <div style={tutorial.wrapper}>
      <h2 style={tutorial.pageTitle}>PathoTrack User Guide</h2>
      <p style={tutorial.pageSubtitle}>
        Follow these steps to upload data, run pipelines, and download results.
      </p>
      <hr />

      {/* =========================
          1. User Registration
      ========================== */}
      <section id="registration" style={tutorial.section}>
        <h3 style={tutorial.subTitle}>Preparation Before Running Pipelines</h3>

        <h4 style={tutorial.sectionHeader}>1. Account Registration</h4>

          <ol style={tutorial.list}>
            <li style={tutorial.listItem}>Navigate to the Home page and select <strong>Get Started</strong>.<br /></li>
            <li style={tutorial.listItem}>Provide your username, email address, and a secure password.<br /></li>
            <li style={tutorial.listItem}>Submit the registration form to create your account.<br /></li>
            <li style={tutorial.listItem}>Upon successful registration, log in to access the dashboard and available analysis pipelines.<br /></li>
        </ol>

      </section>

      {/* =========================
          2. Upload Data
      ========================== */}
      <section id="upload" style={tutorial.section}>
        <h4 style={tutorial.sectionHeader}>
          2. Upload Sequencing Data (BaseSpace)
        </h4>

        <p>
          To submit FASTQ files via Illumina BaseSpace, complete the following steps:
        </p>

        <ol style={tutorial.list}>
          <li style={tutorial.listItem}>If you do not already have a BaseSpace account, complete the{" "}
            <a href="https://basespace.illumina.com/" target="_blank" rel="noopener noreferrer">BaseSpace</a> 
            {" "}account registration process.</li>          

          <li style={tutorial.listItem}>Sign in to your BaseSpace account and create a new project.</li>

          <li style={tutorial.listItem}>
            Upload your FASTQ files to the newly created project.{" "}
            <a href={uploadGuide} target="_blank" rel="noopener noreferrer">Upload to BaseSpace Guide</a>
          </li>

          <li style={tutorial.listItem}>
            Generate a personal access token from the <a href="https://developer.basespace.illumina.com/" target="_blank" rel="noopener noreferrer">BaseSpace Developers</a> Portal.{" "}
            <a href={tokenGuide} target="_blank" rel="noopener noreferrer">Generate BaseSpace Token Guide</a>
          </li>  

          <li style={tutorial.listItem}>Enter and save your BaseSpace access token in the Profile section of the PathoTrack web portal.</li>

        </ol>
      </section>


      <hr style={{ margin: "50px 0" }} />

      {/* =========================
          Pipeline Highlights
      ========================== */}
      <h3 style={tutorial.subTitle}>Pipeline Tutorials</h3>

      <section style={home.section}>
        <h4 style={home.sectionHeader}>CRO Pipeline</h4>
        <p>
          Analyze Carbapenem-Resistant Organisms using dedicated genomic pipelines.
          <br />
          <a href={croGuide}
            target="_blank"
            rel="noopener noreferrer"
            style={tutorial.link}
          >
            View CRO Tutorial →
          </a>
        </p>
      </section>

      <section style={home.section}>
        <h4 style={home.sectionHeader}>Candida auris Pipeline</h4>
        <p>
          High-throughput genomic analysis of <em>Candida auris</em> isolates for outbreak tracking.
          <br />
          <a href={caurisGuide}
            target="_blank"
            rel="noopener noreferrer"
            style={tutorial.link}
          >
            View Candida auris Tutorial →
          </a>
        </p>
      </section>

      <section style={home.section}>
        <h4 style={home.sectionHeader}>SARS-CoV-2 Pipeline</h4>
        <p>
          Analyze SARS-CoV-2 genomes to monitor variants and transmission patterns.
          <br />
          <a href={sarsGuide}
            target="_blank"
            rel="noopener noreferrer"
            style={tutorial.link}
          >
            View SARS-CoV-2 Tutorial →
          </a>
        </p>
      </section>

      <section style={home.section}>
        <h4 style={home.sectionHeader}>PhyloTree / Custom Analysis</h4>
        <p>
          Construct phylogenetic trees and perform advanced genomic analysis.
          <br />
          <a href={phyloGuide}
            target="_blank"
            rel="noopener noreferrer"
            style={tutorial.link}
          >
            View PhyloTree Tutorial →
          </a>
        </p>
      </section>

      <hr style={{ margin: "50px 0" }} />

      {/* =========================
          Contact administrator
      ========================== */}
      <section style={tutorial.section}>
        <h3 style={tutorial.subTitle}>Support & Contact</h3>

        <p>
          For any technical issues with PathoTrack (e.g., job failures, BaseSpace connection errors, or missing notifications), 
          please reach out to the system administrator for assistance.
        </p>
        <p>
          <strong>Technical Support:</strong>{" "}
          <a href="mailto:zl7w2@missouri.edu" className="ms-2">
            <FaEnvelope className="text-primary fs-5" />
          </a>
        </p>

        <p>
          <strong>Official / Administrative Contact:</strong>{" "}
          <a href="mailto:joshitr@health.missouri.edu" className="ms-2">
            <FaEnvelope className="text-primary fs-5"/>
          </a>
        </p>

      </section>

    </div>
  );
};

const Tutorial = () => {
  return (
    <MainLayout>
      <TutorialContent />
    </MainLayout>
  );
};

export default Tutorial;